import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/logo-final.png'


const _hoisted_1 = { class: "bg-accent text-cream-200" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10" }
const _hoisted_4 = { class: "lg:col-span-1" }
const _hoisted_5 = { class: "flex gap-3" }
const _hoisted_6 = ["href", "aria-label"]
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "flex flex-col gap-2.5 text-sm text-cream-200/70" }
const _hoisted_9 = { class: "flex flex-col gap-2.5 text-sm text-cream-200/70" }
const _hoisted_10 = { class: "text-cream-200/50" }
const _hoisted_11 = { class: "border-t border-cream-200/10" }
const _hoisted_12 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-cream-200/40" }
const _hoisted_13 = { class: "flex items-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            src: _imports_0,
            alt: "HomeSweet Bites",
            class: "h-14 w-auto mb-4 brightness-0 invert"
          }, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm text-cream-200/70 leading-relaxed mb-5" }, " Real home-cooked meals made with love, delivered fresh to your door every day. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socials, (social) => {
              return (_openBlock(), _createElementBlock("a", {
                key: social.name,
                href: social.href,
                "aria-label": social.name,
                class: "w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-cream-200/10 hover:bg-brand flex items-center justify-center transition-colors duration-150"
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(social.emoji), 1)
              ], 8, _hoisted_6))
            }), 128))
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "font-display font-bold text-white mb-4" }, "Quick Links", -1)),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickLinks, (link) => {
              return (_openBlock(), _createElementBlock("li", {
                key: link.to
              }, [
                _createVNode(_component_router_link, {
                  to: link.to,
                  class: "hover:text-brand transition-colors duration-150"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(link.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "font-display font-bold text-white mb-4" }, "Opening Hours", -1)),
          _createElementVNode("ul", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (hour) => {
              return (_openBlock(), _createElementBlock("li", {
                key: hour.day,
                class: "flex justify-between gap-4"
              }, [
                _createElementVNode("span", null, _toDisplayString(hour.day), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(hour.time), 1)
              ]))
            }), 128))
          ])
        ]),
        _cache[4] || (_cache[4] = _createStaticVNode("<div><h4 class=\"font-display font-bold text-white mb-4\">Contact Us</h4><ul class=\"flex flex-col gap-3 text-sm text-cream-200/70\"><li class=\"flex items-start gap-2\"><span class=\"mt-0.5\">📍</span><span>Kigali, Rwanda</span></li><li class=\"flex items-center gap-2\"><span>📞</span><a href=\"tel:+250788288199\" class=\"hover:text-brand transition-colors\">+250 788 288 199</a></li><li class=\"flex items-center gap-2\"><span>✉️</span><a href=\"mailto:hello@homesweetbites.rw\" class=\"hover:text-brand transition-colors\">hello@homesweetbites.rw</a></li><li class=\"flex items-center gap-2\"><span>💬</span><a href=\"#\" class=\"hover:text-brand transition-colors\">WhatsApp Order</a></li></ul></div>", 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", null, "© " + _toDisplayString(_ctx.year) + " HomeSweet Bites. All rights reserved.", 1),
        _createElementVNode("span", _hoisted_13, [
          _cache[6] || (_cache[6] = _createTextVNode(" Made with ❤️ in Rwanda ", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "opacity-30" }, "·", -1)),
          _createVNode(_component_router_link, {
            to: "/admin/login",
            class: "opacity-30 hover:opacity-70 transition-opacity duration-200",
            title: "Admin"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Admin", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}